var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 11.833a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.579 11.46C18.78 7.865 15.586 6 12.333 6c-3.252 0-6.447 1.864-8.245 5.46a.83.83 0 0 0 0 .746c1.798 3.597 4.993 5.46 8.245 5.46 3.253 0 6.447-1.863 8.246-5.46a.83.83 0 0 0 0-.745M12.333 16c-2.474 0-5.001-1.35-6.558-4.167 1.557-2.816 4.084-4.166 6.558-4.166s5.002 1.35 6.559 4.166C17.335 14.65 14.807 16 12.333 16",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpen;